import { styled } from '@engyalo/design-system';
import { Box, css, FormControlLabel, Stack, Typography } from '@mui/material';

export const HeaderWrapper = styled(Stack)(
  ({ theme }) => css`
    background-color: ${theme.palette.neutral.var0};
    flex-direction: row;
    justify-content: space-between;
    padding: 1rem 1.8rem;
    flex: 1 0 0;
    max-height: 4.8rem;
    align-items: center;
  `
);

export const StatusIcon = styled(Box)(
  ({ theme }) => css`
    width: 0.4rem;
    height: 0.4rem;
    border-radius: 50%;
    &.online {
      background-color: ${theme.palette.success.main};
    }

    &.offline {
      background-color: ${theme.palette.error.main};
    }
  `
);

export const LabelWrapper = styled(Stack)(
  () => css`
    gap: 1rem;
    align-items: center;
    justify-content: center;
    margin-right: 0.8rem;
    flex-direction: row;
  `
);

export const SwitchWrapper = styled(FormControlLabel)(
  ({ theme }) => css`
    background-color: ${theme.palette.neutral.var20};
    padding: 0.8rem;
    border-radius: 5.5rem;
    max-height: 3.3rem;
  `
);

export const CustomTypography = styled(Typography)(
  () => css`
    text-transform: capitalize;
    min-width: 5.2rem;
  `
);
